import { render, staticRenderFns } from "./volunteer_detail.vue?vue&type=template&id=7ae4a05d&scoped=true"
import script from "./volunteer_detail.vue?vue&type=script&lang=js"
export * from "./volunteer_detail.vue?vue&type=script&lang=js"
import style0 from "./volunteer_detail.vue?vue&type=style&index=0&id=7ae4a05d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae4a05d",
  null
  
)

export default component.exports